export const ellipsisNoteHeaderOptions = [
  { label: 'Print', value: 'print', callback: 'onClickPrint' },
  { label: 'Export', value: 'export', callback: 'onClickExport' }
];
export const ellipsisNoteOptions = [
  { label: 'Update', value: 'edit', callback: 'onRowSelect' },
  { label: 'Delete', value: 'delete', callback: 'onRowDelete' },
];
